module.exports = __webpack_public_path__ + "img/Logo_AJA.293849ff.png";